import { useAppSelector, useGetUserOrgNodesQuery } from '@monorepo/shared';
import { selectLoginAccount } from '@monorepo/shared/store/accountSlice';
import { Outlet } from 'react-router-dom';
import { server, HomeElms } from '../../config/const';
import { t } from 'i18next';
import { selectPermission } from '@monorepo/shared/store/authSlice';
import './CredMain.less';

const CredMain = () => {
  const userPermission = useAppSelector(selectPermission);
  const loginAccount = useAppSelector(selectLoginAccount);
  const ou = useGetUserOrgNodesQuery(
    { server: server, fcName: HomeElms?.fcName },
    {
      skip: userPermission === 'unset'
    }
  );

  return (
    <div className="new-cred-container">
      <div className="left-panel">
        <div className="content">
          <div className="info-container">
            <div className="info-header">
              <div className="title" style={{ marginBottom: '20px' }}>
                {t('common.ouTree.welcomeMsg')}
              </div>
              <div className="login-info">
                {loginAccount?.user_display_info?.map(
                  (obj: Record<string, string>, idx: number) => (
                    <div className="info-item" key={idx}>
                      <div className="name">{obj?.name}</div>
                      <div className="value" style={{ maxWidth: '250px' }}>
                        {obj?.value}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="info-body">
              <div className="user-indicator">
                <i className="icon-fontello-alias-fingerprint icon"></i>
                <span>{loginAccount?.user_type}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-panel">
        <Outlet />
      </div>
    </div>
  );
};

export default CredMain;
